interface Props {
  isFirst: boolean;
  isLast: boolean;
  answered: boolean;
  onPrev: () => void;
  onSubmit: () => void;
  onNext: () => void;
  onFinish: () => void;
}

/** 答题操作按钮组：桌面端显示在题目卡内，移动端渲染进底部操作栏 */
export function ActionButtons({ isFirst, isLast, answered, onPrev, onSubmit, onNext, onFinish }: Props) {
  return (
    <div className="actions">
      {!isFirst && <button className="btn secondary" onClick={onPrev}>上一题</button>}
      {!answered && <button className="btn primary" onClick={onSubmit}>提交</button>}
      {answered && !isLast && <button className="btn primary" onClick={onNext}>下一题</button>}
      {answered && isLast && <button className="btn secondary" onClick={onFinish}>完成</button>}
    </div>
  );
}
